var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorPageLogoGroupDesktop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302.753,
    height: 205.51,
    viewBox: "0 0 302.753 205.51",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f7bed1;stroke:#f7f7f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.446 0.363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.065 35.58)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.435,89.965c3.614-.111,6.924-2.7,10.211-4.043,1.949-.794,3.863-1.642,5.756-2.559.854-.415,1.725-.81,2.556-1.269-.115.063,3.074-1.474,1.5-1.3,6.723-.748,5.477-10.525-1.246-9.2-1.8.354-2.852,1.336-4.3,2.358a57.485,57.485,0,0,1-6.143,3.668c-1.979,1.059-4.141,1.887-6.034,3.093-1.392.884-2.535,2.215-4.016,2.94-3.044,1.5-1.547,6.415,1.709,6.313Z",
    transform: "translate(-20.07 -71.469)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.777 18.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-8.393,79.562c3.327.754,7.326-1.7,10.308-3.007,2.131-.93,4.142-2.111,6.216-3.162,1.424-.724,3.159-2.087,4.238-2.646,3.754-1.943,2.211-8.892-2.259-8.342-2.416.3-3.139,1.269-4.784,2.795A54.687,54.687,0,0,1,.622,68.551C-2.537,70.873-5.59,73.724-8.885,75.8c-1.422.9-1.306,3.354.492,3.76Z",
    transform: "translate(9.857 -62.374)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.292 8.867)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.347,71.1l.157.339A3.43,3.43,0,0,0,19.567,73.2c2.892-.289,5.5-1.977,8.134-3.159,2.512-1.126,4.912-2.672,7.481-3.649,5.423-2.062,3.386-9.941-2.414-8.758-3.758.768-7.412,4.146-10.735,5.994-2.492,1.384-7.343,3.884-5.685,7.475Z",
    transform: "translate(-16.009 -57.514)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.972 28.894)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.421,82.5C52.943,83.99,57.446,81,60.675,79.657c3.44-1.426,6.889-2.282,9.7-4.868,3.76-3.461-2.146-9.367-5.6-5.6C62.85,71.282,59.957,72.02,57.5,73.3c-2.873,1.493-5.923,3.137-8.647,4.858-1.88,1.191-1.269,3.574.569,4.347Z",
    transform: "translate(-47.708 -67.976)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.453 57.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.971,99.71c5.414-2.291,9.719-6.623,14.734-9.545,1.857-1.08,2.014-3.9.867-5.513-1.34-1.884-3.681-1.935-5.513-.867-2.469,1.438-4.508,3.637-6.748,5.4-2.257,1.773-5.176,3.3-6.924,5.6-1.832,2.418.574,6.195,3.584,4.922Z",
    transform: "translate(-54.75 -83.085)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.851 98.755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.225,128.229c4.841-5.27,10.008-10.253,14.748-15.561,4.661-5.22-3.905-11.788-7.569-5.84-1.02,1.654-2.245,3.025-3.151,4.77a47.016,47.016,0,0,1-3.662,5.735c-2.025,2.82-5.149,6.118-4.46,9.816a2.465,2.465,0,0,0,4.095,1.08Z",
    transform: "translate(-45.033 -104.471)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.854 111.973)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.016,131.11c3.046-.66,6.005-3.584,7.952-5.934,2.1-2.54,4.742-4.646,6.185-7.671,2.487-5.211-6.235-8.871-8.264-3.457-1.962,5.239-9.215,8.616-8.968,14.7a2.762,2.762,0,0,0,3.1,2.364Z",
    transform: "translate(-18.915 -111.376)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.937 140.067)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-.194,147.1c-.038.647,1.166-1.246,1.468-1.688.944-1.394,1.773-2.858,2.592-4.326,1.752-3.134,3.947-5.907,5.808-8.947,2.749-4.491-4.8-8.706-6.951-4.064-1.97,4.236-3.886,8.289-5.557,12.682-.984,2.588-2.829,5.216-.808,7.772,1.177,1.487,3.356.134,3.448-1.428Z",
    transform: "translate(4.549 -126.052)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.879 133.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-18.508,144.457c2.508-.664,4.4-4.709,5.618-6.765.978-1.65,1.776-3.409,2.665-5.109.046-.09,1.708-3.654.4-1.5.463-.762,1.426-1.235,1.912-2.117,1.424-2.588-.3-7.01-3.769-6.566-6.288.806-6.1,8.185-7.831,13.063-.4,1.114-3.145,10.1,1.007,9Z",
    transform: "translate(20.773 -122.366)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.419 103.014)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.687,125.052a13.842,13.842,0,0,1,2.349-1.047,34.451,34.451,0,0,0,5.391-3.513c3-2.245,6.355-4.6,8.764-7.489a3.75,3.75,0,0,0-5.3-5.3,61.736,61.736,0,0,0-4.68,4.837c-1.729,1.784-3.624,3.39-5.364,5.159-1.757,1.786-5.107,4.234-3.651,7.031a1.608,1.608,0,0,0,2.492.322Z",
    transform: "translate(1.163 -106.696)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.303 96.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-14.819,121.87a42.205,42.205,0,0,0,2.992-7.533c.68-2.23,1.966-4.106,2.626-6.273a3.787,3.787,0,0,0-5.505-4.232c-3.053,1.886-3.18,5.339-3.1,8.609.073,2.975-.634,6.715.624,9.43a1.378,1.378,0,0,0,2.364,0Z",
    transform: "translate(17.94 -103.319)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.805)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.1,60.183c3.683.258,7.336.563,11.086.666,4.342.123,8.721,1.6,12.213-1.512a3.122,3.122,0,0,0,0-4.384c-3.658-3.25-9.292-1.843-13.85-1.281-3.268.4-7.785.042-10.733,1.771-2.282,1.338-1.15,4.569,1.284,4.74Z",
    transform: "translate(-46.576 -52.882)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.272 16.155)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M77.767,62.379c-.871,2.764,3,3.943,4.975,4.305A148.766,148.766,0,0,1,97.57,69.832c5.18,1.5,7.224-7.152,2.165-7.856a72.7,72.7,0,0,0-13.442-.565c-1.995.1-5.513,1.018-7.374.314a.951.951,0,0,0-1.152.655Z",
    transform: "translate(-77.641 -61.321)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.162 42.533)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M82.148,79.741a66,66,0,0,0,11.179,3.534c2.99.63,6.733,1.692,9.774,1.44,3.44-.285,5.555-4.338,2.9-7.014-2.889-2.915-7.2-1.8-10.927-2-3.913-.214-9.234-1.317-12.931.149a2.039,2.039,0,0,0,0,3.892Z",
    transform: "translate(-80.718 -75.101)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(239.707 70.547)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M91.311,96.68c7.184,2.958,15.462,1.005,22.883,2.85,8.007,1.991,8.057-11.595,0-9.592-7.424,1.845-15.7-.107-22.883,2.85a2.04,2.04,0,0,0,0,3.892Z",
    transform: "translate(-89.884 -89.735)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.053 141.307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.112,126.7c-1.52.071-2.2.693-3.321,1.652-1.738,1.48-3.543,2.87-5.226,4.416A58.57,58.57,0,0,0,26.535,141c-2.575,3.392,2.286,7.349,5.523,5.523,1.608-.907,1.945-1.924,2.7-3.461a27.378,27.378,0,0,1,3.394-4.939c2.071-2.584,5.188-5.551,5.877-8.913a2.007,2.007,0,0,0-1.912-2.512Z",
    transform: "translate(-25.81 -126.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.843 162.953)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.652,138.223c-2.186,1.688-2.891,4.227-3.687,6.765a47.5,47.5,0,0,0-1.838,11.838c-.341,5.785,9.416,5.72,8.938,0a70.678,70.678,0,0,1-.358-11.576c.159-2.056.59-5.3-1.219-6.792a1.552,1.552,0,0,0-1.836-.235Z",
    transform: "translate(-12.118 -138.007)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.384 182.577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-10.316,150.082c-.953,2.879.888,6.514,1.537,9.365a27.677,27.677,0,0,0,2.912,8.417c4.047,6.643,13.406-1.775,7.923-6.114a13.431,13.431,0,0,1-3.721-5.3c-.574-1.214-1.11-2.446-1.731-3.637-.639-1.225-1.652-2.165-2.309-3.333a2.554,2.554,0,0,0-4.611.6Z",
    transform: "translate(10.584 -148.259)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 97.129)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-28.805,125.776a31.8,31.8,0,0,0,4.47-6.723c1.321-2.914,2.406-5.955,3.608-8.922,2.519-6.218-8.237-9.5-10.255-2.827-.911,3.015-1.595,6.017-2.427,9.045-.733,2.672-2.6,4.87-1.681,7.768.77,2.437,4.414,4,6.285,1.66Z",
    transform: "translate(35.337 -103.622)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.282 52.949)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-19.476,100.448C-17.8,98.6-15.766,97.1-14.17,95.14c1.539-1.893,2.925-4.456,4.768-6.009,4.918-4.141-2.485-11.79-7.136-7.135a16.631,16.631,0,0,0-2.569,3.733c-.882,1.53-2.041,2.883-2.887,4.435-1.595,2.929-3.36,5.481-2.542,8.947a3.049,3.049,0,0,0,5.059,1.336Z",
    transform: "translate(24.742 -80.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.508 72.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.042,108.829A32.87,32.87,0,0,0,37.9,103.352c2.728-2.069,6.583-4.152,8.519-7.037,2.847-4.234-4.058-8.27-6.844-4-.389.6-1.784,1.21-2.387,1.671-1.807,1.386-3.52,2.891-5.326,4.278-2.638,2.029-6.455,3.275-8.08,6.329a2.918,2.918,0,0,0,3.256,4.236Z",
    transform: "translate(-23.436 -90.496)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.262 62.755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.347,105.039c.674-1.124,1.987-1.775,2.933-2.672A35.775,35.775,0,0,0,7.1,98.99c2.035-2.469,4.78-4.232,6.813-6.658a3.966,3.966,0,0,0-5.605-5.607A34.312,34.312,0,0,0,.861,96.381c-1.388,2.492-4.192,5.791-2.749,8.658a1.889,1.889,0,0,0,3.235,0Z",
    transform: "translate(2.29 -85.665)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.122 78.321)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.885,102.716a16.764,16.764,0,0,0,7.06-.427c2.454-.57,4.985-.538,7.473-.972,4.77-.831,2.659-8.924-2.014-7.307-1.976.683-4.058.936-6.009,1.665-1.9.712-3.846,2.11-5.877,2.358-2.406.293-3.532,4.141-.634,4.682Z",
    transform: "translate(-68.16 -93.797)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.673 47.602)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M110.253,80.444c.536,4.3,5.2,5.984,8.683,7.713,1.252.622,2.546,1.185,3.775,1.851-.218-.119,1.514.919,1.082.6-.837-.62,1.639,1.564,1.932,1.721a5.043,5.043,0,0,0,7.314-2.977l.08-.291a5.153,5.153,0,0,0-1.344-5.079c-2.33-1.964-4.818-2.4-7.726-2.881a49.956,49.956,0,0,1-10.431-3.22,2.665,2.665,0,0,0-3.365,2.563Z",
    transform: "translate(-110.239 -77.749)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.233 161.629)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-29.975,139.632c-.188,3.564,1.281,7.749,2.489,11.086,1.317,3.641,3.769,7.447,8.13,6.574,2.131-.427,3-2.772,2.649-4.667-.3-1.631-1.306-2.228-2.28-3.419a19.2,19.2,0,0,1-1.717-2.948c-.657-1.2-1.283-2.42-1.939-3.622a44.63,44.63,0,0,0-2.9-4.2,2.4,2.4,0,0,0-4.433,1.2Z",
    transform: "translate(29.992 -137.316)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorPageLogoGroupDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-page-logo-group-desktop.da30fb6f38532fa4d184ffb1c7700cd1.svg";